<template>
  <van-popup v-model:show="showDear" position="bottom" safe-area-inset-bottom :style="{ height: '80%' }">
    <DealerList
      :fromTyre="from === 'tyre'"
      :from="from"
      :showNum="showNum"
      :isShowPhone="isShowPhone"
      @selectCityFn="selectCityFn"
      :selectCity="selectCity"
      @selectResultFn="selectResultFn"
    />
  </van-popup>
  <SelectCity :fromTyre="from === 'tyre'" :showNum="showCity" @getCity="getCity" />
</template>

<script>
import { reactive, toRefs, watch, onMounted } from 'vue'
import DealerList from '@/components/dealer/DealerList'
import SelectCity from '@/components/common/SelectCity.vue'
import { useStore } from 'vuex'
import { getSession } from '@/util'
import { onBeforeRouteLeave, useRoute } from 'vue-router'
export default {
  components: {
    DealerList,
    SelectCity
  },
  emits: ['dealerFn'],
  props: ['showNum', 'from', 'isShowPhone'],
  setup(props, { emit }) {
    let { showNum, from, isShowPhone } = toRefs(props)
    const store = useStore()
    const route = useRoute()
    const state = reactive({
      showDear: false,
      showCity: 0,
      selectCity: '',
      provinceCityList: [],
      provinceCityColumnsList: [],
      showNum,
      from,
      close,
      isShowPhone
    })
    onBeforeRouteLeave(() => {
      state.showDear = false
    })
    watch(
      () => showNum.value,
      () => {
        state.showDear = true
      }
    )
    watch(
      () => state.close,
      () => {
        state.showDear = false
      }
    )
    const selectCityFn = async () => {
      state.showDear = false
      state.showCity += 1
    }
    const getCity = val => {
      state.showDear = true
      state.selectCity = val
    }
    const selectResultFn = val => {
      state.showDear = false
      if (val) {
        emit('dealerFn', val)
        let method = route.path === '/tyreDetail' ? 'setDealerInfo' : 'setLoyaltyDealerInfo'
        store.dispatch(method, val)
      }
    }

    onMounted(() => {
      if (state.from === 'tyre') {
        state.selectCity = getSession('tyreCity')
      }
    })
    return {
      ...toRefs(state),
      selectCityFn,
      selectResultFn,
      getCity
    }
  }
}
</script>

<style lang="scss" scoped></style>
